import { KeyboardEvent, useId, useState } from 'react';
import type { LookupItem } from '../types';

export function addressLookupId(item: LookupItem): string {
  return String(item._id || item.id || '');
}

export function addressLookupLabel(item: LookupItem): string {
  return item.label || item.name || String(item.denumire || item.address || item.adresa || item._id || item.id || '');
}

interface AddressComboboxProps {
  label: string;
  value: string;
  selectedId: string;
  items: LookupItem[];
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  onSearchChange(value: string): void;
  onSelect(item: LookupItem): void;
}

export function AddressCombobox({ label, value, selectedId, items, className = '', placeholder = 'Denumire sau adresă…', disabled = false, required = false, onSearchChange, onSelect }: AddressComboboxProps) {
  const inputId = useId();
  const listId = useId();
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const options = items.filter((item) => addressLookupId(item));

  function choose(item: LookupItem) {
    onSelect(item);
    setOpen(false);
    setActiveIndex(0);
  }

  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (disabled) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setOpen(true);
      setActiveIndex((current) => Math.min(options.length - 1, current + 1));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setOpen(true);
      setActiveIndex((current) => Math.max(0, current - 1));
    } else if (event.key === 'Enter' && open && options[activeIndex]) {
      event.preventDefault();
      choose(options[activeIndex]);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  return <div className={`address-combobox ${className}`.trim()}>
    <label htmlFor={inputId}>{label}</label>
    <input id={inputId} className="input" role="combobox" aria-autocomplete="list" aria-expanded={open} aria-controls={listId} aria-activedescendant={open && options[activeIndex] ? `${listId}-${addressLookupId(options[activeIndex])}` : undefined} autoComplete="off" value={value} placeholder={placeholder} disabled={disabled} required={required} onFocus={() => setOpen(true)} onBlur={() => window.setTimeout(() => setOpen(false), 100)} onKeyDown={handleKeyDown} onChange={(event) => { onSearchChange(event.currentTarget.value); setOpen(true); setActiveIndex(0); }} />
    {open && !disabled && <div id={listId} className="address-combobox__menu" role="listbox">{options.length > 0 ? options.map((item, index) => { const id = addressLookupId(item); return <button id={`${listId}-${id}`} type="button" role="option" aria-selected={selectedId === id} className={selectedId === id || activeIndex === index ? 'active' : ''} key={id} onMouseDown={(event) => event.preventDefault()} onClick={() => choose(item)}>{addressLookupLabel(item)}</button>; }) : <span className="address-combobox__empty">Nicio adresă găsită.</span>}</div>}
  </div>;
}
